import { createContext, useContext, useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

const ConfirmContext = createContext(null);

export const ConfirmProvider = ({ children }) => {
    const [confirmState, setConfirmState] = useState(null);
    const [resolveFn, setResolveFn] = useState(null);
    const [rejectFn, setRejectFn] = useState(null);

    const confirm = (options = {}) => {
        return new Promise((resolve, reject) => {
            setConfirmState(options);
            setResolveFn(() => resolve);
            setRejectFn(() => reject);
        });
    };

    const handleClose = confirmed => {
        setConfirmState(null);
        if (confirmed) {
            resolveFn?.();
        } else {
            rejectFn?.();
        }
    };

    useEffect(() => {
        if (confirmState) {
            const confirmModal = document.querySelector('.confirm-backdrop');
            confirmModal.style.zIndex = '99998';
        }
    }, [confirmState]);

    return (
        <ConfirmContext.Provider value={confirm}>
            {children}

            <Modal
                show={Boolean(confirmState)}
                className="confirm-modal"
                backdropClassName="confirm-backdrop"
                onHide={() => handleClose(false)}
                centered
                backdrop="static"
                style={{ zIndex: 99999 }}
                container={document.body}
            >
                {/* <Modal.Header closeButton>
                        <Modal.Title as="h4">{confirmState.title || 'Confirmação'}</Modal.Title>
                    </Modal.Header> */}
                <Modal.Body>{confirmState?.message || 'Tem certeza que deseja continuar?'}</Modal.Body>
                <Modal.Footer>
                    <Button variant="outlined" size="sm" onClick={() => handleClose(false)}>
                        {confirmState?.cancelText || 'Cancelar'}
                    </Button>
                    <Button variant="success-600 " size="sm" onClick={() => handleClose(true)}>
                        {confirmState?.confirmText || 'Confirmar'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </ConfirmContext.Provider>
    );
};

export const useConfirm = () => {
    const context = useContext(ConfirmContext);
    if (!context) throw new Error('useConfirm deve ser usado dentro de um ConfirmProvider');
    return context;
};
